import { Box, Typography } from "@mui/material";
import ConnectedUserDisplay from "./ConnectedUser/ConnectedUserDisplay";

import "./TanguayHeader.scss";

const TanguayHeader: React.FC = () => {
  return (
    <div className="tanguay-header">
      <Box className="tanguay-header-logo" />
      <Typography component="h2" className="titre-application">
        Gestionnaire d&apos;entrepôt
      </Typography>
      <ConnectedUserDisplay />
    </div>
  );
};
export default TanguayHeader;
